module.exports = __webpack_public_path__ + "img/20m5.8799f95c.jpg";